module.exports = __webpack_public_path__ + "img/SH2D_30007.a37b9232.png";